import { render, staticRenderFns } from "./CommonIcon.vue?vue&type=template&id=216e7ea3&"
import script from "./CommonIcon.vue?vue&type=script&lang=ts&"
export * from "./CommonIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../sis/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports